import { CircularProgress } from "@mui/material";
import { lazy, Suspense } from "react";
import { Route, Routes } from "react-router";
import { CardErrorsPage } from "../components/CardErrorsPage.tsx";
import { GuidePage } from "../components/frontpage/GuidePage";
import { LandingPage } from "../components/frontpage/LandingPage";
import { ManualDispatchPage } from "../components/ManualDispatchPage.tsx";
import { MySignedCards } from "../components/MySignedCards.tsx";
import { SearchPage } from "../components/SearchPage.tsx";
import { SignatureListFromUrlParam } from "../components/SignatureListFromUrlParam.tsx";
import { App } from "./App";
import { ErrorPage } from "./ErrorPage";

const DocsPage = lazy(() => import("./DocsPage.tsx"));

export const AppRoutes = () => (
  <Routes>
    <Route element={<App />} errorElement={<ErrorPage />}>
      <Route path="/" element={<LandingPage />} />
      <Route path="/guide" element={<GuidePage />} />
      <Route
        path={"projects/:projectId"}
        element={<SignatureListFromUrlParam />}
      />
      <Route path={"/search"} element={<SearchPage />} />
      <Route path={"/errors"} element={<CardErrorsPage />} />
      <Route path={"/my-signed-cards"} element={<MySignedCards />} />
      <Route path={"/manual-dispatch"} element={<ManualDispatchPage />} />
    </Route>
    <Route
      path="/docs"
      element={
        <Suspense
          fallback={<CircularProgress aria-label="Loading API documentation" />}
        >
          <DocsPage />
        </Suspense>
      }
    />
    <Route path={"callback"} />
  </Routes>
);
